import { Component, OnInit, ViewChild, ElementRef, Output, EventEmitter, Input, OnChanges, ChangeDetectorRef } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';

import { DynamicDialogRef, DialogService, DynamicDialogConfig } from 'primeng/dynamicdialog';

import { HelperService, HTTPService, DataService, CalculationService, ValidationService, DateService } from 'app/services';
import { datetimeFormat } from '../../../constants/date-time-format';
import * as moment from 'moment';
@Component({
  selector: 'app-report-schedule',
  templateUrl: './report-schedule.component.html',
  styleUrls: ['./report-schedule.component.scss'],
  providers: [DialogService],
  animations: [
    trigger('toggleBox', [
      state(
        'open',
        style({
          height: '135px',
        })
      ),
      state(
        'closed',
        style({
          height: '0px',
        })
      ),
      transition('open => closed', [animate('0.0s')]),
      transition('closed => open', [animate('0.0s')]),
    ]),
  ],
})
export class ReportScheduleComponent implements OnInit {
  isLoading = false;
  frequencyType: any;
  day: any;
  month: any;
  role: string = '';
  company: any = {};
  shopIds: any = [];
  title = 'Schedule business summary report';
  subTitle = `Schedule a business summary report containing gross sales, collected receipts, account receivables, average income per order, detailed sales stats and labor stats. This summary will be sent
        out on a selected emails based on the schedule of your choice`;
  type = 'businessSummary';

  scheduleList = [
    { name: 'Daily', value: 'daily' },
    { name: 'Weekly', value: 'weekly' },
    { name: 'Monthly', value: 'monthly' },
    { name: 'Annually', value: 'annually' },
  ];
  weekDays = [
    { name: 'Sunday', value: 0 },
    { name: 'Monday', value: 1 },
    { name: 'Tuesday', value: 2 },
    { name: 'Wednesday', value: 3 },
    { name: 'Thursday', value: 4 },
    { name: 'Friday', value: 5 },
    { name: 'Saturday', value: 6 },
  ];
  monthlyOptions = [
    { name: '1st of the month', value: 1, label: 1 },
    { name: '2nd of the month', value: 2, label: 2 },
    { name: '3rd of the month', value: 3, label: 3 },
    { name: '4th of the month', value: 4, label: 4 },
    { name: '5th of the month', value: 5, label: 5 },
    { name: '6th of the month', value: 6, label: 6 },
    { name: '7th of the month', value: 7, label: 7 },
    { name: '8th of the month', value: 8, label: 8 },
    { name: '9th of the month', value: 9, label: 9 },
    { name: '10th of the month', value: 10, label: 10 },
    { name: '11th of the month', value: 11, label: 11 },
    { name: '12h of the month', value: 12, label: 12 },
    { name: '13th of the month', value: 13, label: 13 },
    { name: '14th of the month', value: 14, label: 14 },
    { name: '15th of the month', value: 15, label: 15 },
    { name: '16th of the month', value: 16, label: 16 },
    { name: '17th of the month', value: 17, label: 17 },
    { name: '18th of the month', value: 18, label: 18 },
    { name: '19th of the month', value: 19, label: 19 },
    { name: '20th of the month', value: 20, label: 20 },
    { name: '21th of the month', value: 21, label: 21 },
    { name: '22th of the month', value: 22, label: 22 },
    { name: '23th of the month', value: 23, label: 23 },
    { name: '24th of the month', value: 24, label: 24 },
    { name: '25th of the month', value: 25, label: 25 },
    { name: '26th of the month', value: 26, label: 26 },
    { name: '27th of the month', value: 27, label: 27 },
    { name: '28th of the month', value: 28, label: 28 },
    { name: 'Last day', value: 'last-day-month', label: 'Last day' },
  ];
  selectedValue: any = {};
  selectedMonth: any = {};
  selectedDay = '';
  closeAfterAction = false;
  selectedDate: any;
  customerSearchResults = [];
  customerFieldFocus: boolean = false;
  isInvalid: boolean = false;

  date = new Date();
  customerSearchData;
  selectedCustomers = [];
  selectItem: any = '';
  businessSummaryReportInfo: any = {};
  tooltip = `Report will be generated and sent out at 12 midnight`;
  userPlaceholder = `Send reports to the following users*`;
  isXMLSendToFTP: boolean = false;
  isMidasRoyaltyReportsEnable : boolean = false;
  showXMLToggle: boolean = false;
  isSupportUser: boolean = false;
  isRoyaltyReport: boolean = false;

  constructor(
    private helperService: HelperService,
    private httpService: HTTPService,
    private dynamicDialogRef: DynamicDialogRef,
    private dataService: DataService,
    private dateService: DateService,
    private dialogService: DialogService,
    private cdr: ChangeDetectorRef,
    private validationService: ValidationService,
    private dynamicDialogConfig: DynamicDialogConfig
  ) {}

  ngOnInit() {
    const { shopIds, title, subTitle, type, isRoyaltyReport } = this.dynamicDialogConfig.data;
    this.isRoyaltyReport = isRoyaltyReport;
    this.title = title ? title : this.title;
    this.subTitle = subTitle ? subTitle : this.subTitle;
    this.type = type ? type : this.type;
    if(this.type === 'royaltyReport') {
      this.tooltip = `This report will be generated and sent on the last day of the month at 11:59pm`;
      this.userPlaceholder = `Send a copy of the PDF report to the following emails*`
    }
    this.shopIds = shopIds;
    this.isMidasRoyaltyReportsEnable = this.dataService.isMidasRoyaltyReportsEnable;
    this.getCompanyDetails();
  }

  /** fetch company details */
  getCompanyDetails() {
    return new Promise((resolve, reject) => {
      const { companyId, isSupportUser } = this.helperService.getCompany();
      this.isSupportUser = isSupportUser;

      this.httpService.getCompanyDetails(companyId).then(
        (company) => {
          if (company) {
            this.showXMLToggle = company.companyType === 'PROD' && company.status === "Live";
            const { businessSummaryReportInfo, royaltyReportInfo, appsettings } = company.shop;
            
            this.isXMLSendToFTP = appsettings.isXMLSendToFTP;
            this.businessSummaryReportInfo = this.type === 'royaltyReport' ? royaltyReportInfo : businessSummaryReportInfo;

            if (this.businessSummaryReportInfo.users?.length) {
              this.selectedValue = this.scheduleList[this.scheduleList.findIndex((x) => x.value === this.businessSummaryReportInfo.intervalType)];
              if (this.selectedValue.value === 'weekly') {
                const datOfWeek = moment(this.businessSummaryReportInfo.intervalValue).format('dddd');
                this.day = this.weekDays[this.weekDays.findIndex((x) => x.name === datOfWeek)];
              } else if (this.selectedValue.value === 'monthly') {
                if (this.businessSummaryReportInfo.intervalValue === 'last-day-month') {
                  this.month = this.monthlyOptions[this.monthlyOptions.findIndex((x) => x.value === this.businessSummaryReportInfo.intervalValue)];
                } else {
                  this.month = this.monthlyOptions[this.monthlyOptions.findIndex((x) => x.value === parseInt(this.businessSummaryReportInfo.intervalValue))];
                }
              } else if (this.selectedValue.value === 'annually') {
                this.selectedDate = this.dateService.formatDate(new Date(this.businessSummaryReportInfo.intervalValue), datetimeFormat.mmmdyyyy);
              }
              this.selectedDay = this.businessSummaryReportInfo.intervalValue;
              this.selectedDate = this.selectedValue.value === 'annually' ? new Date(this.selectedDate) : this.selectedDate;
              this.frequencyType = this.businessSummaryReportInfo.intervalType;
              this.selectedCustomers = this.businessSummaryReportInfo.users;
            } else {
              if (this.type === 'royaltyReport') {
                this.frequencyType = 'monthly';
                this.businessSummaryReportInfo.intervalValue = 'last-day-month';
                this.month = {
                  label: 'Last day',
                  name: 'Last day',
                  value: 'last-day-month',
                };
          
                this.selectedValue = {
                  name: 'Monthly',
                  value: 'monthly',
                };
                this.selectedDay = 'last-day-month';
              } else {
              this.selectedValue = this.scheduleList[0];
              this.frequencyType = this.scheduleList[0].value
            }}
            this.checkValidation();
          }
          resolve({});
        },
        (err) => {
          reject(err);
          this.helperService.showToaster('error', err);
        }
      );
    });
  }

  closeDialog() {
    this.dynamicDialogRef.close();
  }

  handleSwitchChange(event) {
    this.isXMLSendToFTP = event;
  }

  onSelect($event, type) {
    if (type === 'frequency') {
      this.selectedValue = $event;
      this.selectedDay = '';
      this.day = '';
      this.selectedDate;
      this.frequencyType = this.selectedValue.value;
    } else if (type === 'weekday') {
      this.day = $event;
      this.selectedDay = this.dateService.formatDate(this.dateService.getDayByDayName($event.value), datetimeFormat.yyymmdd);
    } else if (type === 'monthly') {
      this.selectedDay = '';
      this.month = $event;
      this.selectedDay = $event.value;
    }
    this.checkValidation();
  }

  /* Only called when customer changes search text for customer search */
  onCustomerSearchChange(event: any) {
    this.customerSearchData = event;
    this.cdr.detectChanges();
  }

  customerSearch(event: any) {
    this.isLoading = true;
    let conf = {
      role: '',
      fetchInActive: true,
      activeStatus: true,
      search: event.trim(),
    };
    this.httpService.searchEmpolyees(event.trim(), conf).then(
      (customers: any[]) => {
        if (customers && customers.length) {
          customers = customers.map((cust: any) => {
            if (cust.userId) {
              return cust;
            }
          });
        }

        this.customerSearchResults = customers;
        this.cdr.detectChanges();
        this.isLoading = false;
      },
      (err) => {
        this.isLoading = false;
        this.helperService.showToaster('error', err);
      }
    );
  }
  onCustomerSelect($event) {
    this.isLoading = false;
    if ($event && !$event.email) return;
    if (!this.selectedCustomers.includes($event.email) && !this.selectedCustomers.includes($event.email)) {
      this.selectedCustomers.push($event.email);
      this.selectItem = $event.email;
      this.selectItem = '';
      this.onSearchClear();
    }
    this.checkValidation();
  }

  onAddEmailSelect(value: string) {
    if (this.validationService.validateEmail(value)) {
      if (!this.selectedCustomers.includes(value)) {
        this.selectedCustomers.push(value);
        this.selectItem = value;
        this.selectItem = '';
        this.onSearchClear();
        this.customerSearchResults = [];
        this.helperService.showToaster('success', 'Email added');
      }
      this.checkValidation();
    } else {
      this.selectItem = value;
      this.customerSearchResults = [];
      this.helperService.showToaster('error', 'Invalid email');
    }
  }
  onSearchClear() {
    this.isLoading = false;
    this.customerSearchResults = [];
    this.checkValidation();
  }

  handleRemoveFilter(key: string, id: string, i: number) {
    if (i !== -1) {
      this.selectedCustomers.splice(i, 1);
    }
    this.checkValidation();
  }

  onDateTimeChange($event) {
    this.selectedDay = this.dateService.formatDate($event, datetimeFormat.yyymmdd);
    this.checkValidation();
  }

  checkValidation() {
    if (this.frequencyType === 'weekly' || this.frequencyType === 'monthly') {
      if (!this.selectedDay) {
        this.isInvalid = true;
      } else {
        this.isInvalid = (this.type !== 'royaltyReport' && this.selectedCustomers.length === 0) ? true : false;
      }
    } else if (this.frequencyType === 'annually') {
      if (!this.selectedDate) {
        this.isInvalid = true;
      } else {
        this.isInvalid = (this.type !== 'royaltyReport' && this.selectedCustomers.length === 0) ? true : false;
      }
    } else if (this.frequencyType === 'daily') {
      this.isInvalid = (this.type !== 'royaltyReport' && this.selectedCustomers.length === 0) ? true : false;
    }
  }

  onScheduleBusinessSummary() {
    this.isLoading = true;
    const businessSummary = {
      intervalType: this.frequencyType || {},
      users: this.selectedCustomers,
      intervalValue: this.selectedDay || '',
    };
    if (this.shopIds) {
      businessSummary['shopIds'] = this.shopIds;
    }
    this.httpService.businessSummarySetInterval(businessSummary).then(
      (res) => {
        this.closeDialog();
      },
      (err) => {
        this.isLoading = false;
      }
    );
  }

  onScheduleRoyaltyReport() {
    this.isLoading = true;
    const summary = {
      intervalType: this.frequencyType,
      users: this.selectedCustomers,
      intervalValue: this.selectedDay || '',
      isXMLSendToFTP: this.isXMLSendToFTP
    };
    if (this.shopIds) {
      summary['shopIds'] = this.shopIds;
    }
    this.httpService.royaltyReportSetInterval(summary).then(
      (res) => {
        this.closeDialog();
      },
      (err) => {
        this.isLoading = false;
      }
    );
  }

  onSubmit() {
    if (this.type === 'businessSummary') {
      this.onScheduleBusinessSummary();
    } else if (this.type === 'royaltyReport') {
      this.onScheduleRoyaltyReport();
    }
  }
}
